/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Senddrafts_Sendcount3Inputs */

const en_coinvestments_senddrafts_sendcount3 = /** @type {(inputs: Coinvestments_Senddrafts_Sendcount3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send now (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Send now ({count})" |
*
* @param {Coinvestments_Senddrafts_Sendcount3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_sendcount3 = /** @type {((inputs: Coinvestments_Senddrafts_Sendcount3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Sendcount3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_sendcount3(inputs)
});
export { coinvestments_senddrafts_sendcount3 as "coInvestments_sendDrafts_sendCount" }